export default __webpack_public_path__ + "static/media/fortuneIconL.82d8ae0e.svg";